import { createFileRoute, redirect } from '@tanstack/react-router'

// The Xero sign-in callback already returns to the organisation's integrations page;
// this older settings address stays as a redirect for bookmarks and old guide links.
export const Route = createFileRoute('/_authenticated/settings/integrations')({
  beforeLoad: () => {
    throw redirect({
      to: '/organizations/settings/integrations',
      replace: true,
    })
  },
})
